import { EditorContent } from '@tiptap/react'
import styled from 'styled-components'

export const CustomEditorContent = styled(EditorContent)<{
  $isFullScreen: boolean
  $placeholder: string
}>`
  outline: none;

  > div {
    outline: none;
    padding: ${(props) => (props.$placeholder ? 'var(--spacer-1)' : 0)};
    margin-bottom: var(--spacer-4);
  }

  .tiptap p.is-editor-empty:first-child::before {
    content: '${(props) => props.$placeholder}';
    float: left;
    height: 0;
    pointer-events: none;
    color: var(--gray-600);
  }
`

CustomEditorContent.displayName = 'CustomEditorContent'

export const CustomPostContent = styled(CustomEditorContent)`
  > div {
    min-height: auto;
  }
`

CustomPostContent.displayName = 'CustomPostContent'

export const TipTapContainer = styled.div<{ $textAreaHeight: string }>`
  height: ${({ $textAreaHeight }) => $textAreaHeight};
  min-height: 3rem;
`

TipTapContainer.displayName = 'TipTapContainer'
